// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import Message from './Message'
import { SESSION_TIMEOUT_WARNING_NOTIFICATION_ID } from './constants'

const sessionTimeoutWarning = timestamp => ({
  uid: SESSION_TIMEOUT_WARNING_NOTIFICATION_ID,
  title: 'Session Expiration Warning',
  autoDismiss: 0,
  dismissible: false,
  children: (
    <Message timestamp={timestamp} />
  ),
})

export default sessionTimeoutWarning
